export default "__VITE_ASSET__c1777090__"